/**
 * 字符串工具
 */

'use strict';


const AllHans = require('./str-hans');
const AllHant = require('./str-hant');

const traditionalizeString = function(str) {
  if (typeof str !== "string") {
    return '';
  }
  var result = '',
    ss = AllHans,
    tt = AllHant;
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 10000 && ss.indexOf(str.charAt(i)) != -1) {
      result += tt.charAt(ss.indexOf(str.charAt(i)));
    } else {
      result += str.charAt(i);
    }
  }
  return result;
}
const simpleLizeString = function (str) {
  if (typeof str !== "string") {
    return '';
  }
  var result = '',
    ss = AllHans,
    tt = AllHant;
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 10000 && tt.indexOf(str.charAt(i)) != -1) {
      result += ss.charAt(tt.indexOf(str.charAt(i)));
    } else {
      result += str.charAt(i);
    }
  }
  return result;
};

export {
  traditionalizeString,
  simpleLizeString
}


// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/index/lang/traditionalize/str_util.js